import React, { useState, useEffect } from 'react';
import './OrderQRCode.css';
import { generateOrderQRCode } from '../../utils/qrCodeUtils';

const OrderQRCode = ({ orderId, size = 'medium', showTitle = true, className = '' }) => {
  const [qrCodeUrl, setQrCodeUrl] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Size configurations
  const sizeConfig = {
    small: { width: 120, fontSize: '0.8rem' },
    medium: { width: 180, fontSize: '0.9rem' },
    large: { width: 250, fontSize: '1rem' }
  };

  const config = sizeConfig[size] || sizeConfig.medium;

  useEffect(() => {
    const generateQR = async () => {
      if (!orderId) {
        setError('Order ID is required');
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        setError(null);
        
        const qrDataUrl = await generateOrderQRCode(orderId, {
          width: config.width,
          margin: 2
        });
        
        setQrCodeUrl(qrDataUrl);
      } catch (err) {
        console.error('Failed to generate QR code:', err);
        setError('Failed to generate QR code');
      } finally {
        setLoading(false);
      }
    };

    generateQR();
  }, [orderId, config.width]);

  const handleDownload = () => {
    if (!qrCodeUrl) return;

    const link = document.createElement('a');
    link.href = qrCodeUrl;
    link.download = `order-${orderId}-qr.png`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  if (loading) {
    return (
      <div className={`qr-code-container ${size} ${className}`}>
        {showTitle && <h4 className="qr-title">Pickup QR Code</h4>}
        <div className="qr-loading">
          <div className="loading-spinner"></div>
          <p>Generating QR code...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className={`qr-code-container ${size} ${className}`}>
        {showTitle && <h4 className="qr-title">Pickup QR Code</h4>}
        <div className="qr-error">
          <p>❌ {error}</p>
        </div>
      </div>
    );
  }

  return (
    <div className={`qr-code-container ${size} ${className}`}>
      {showTitle && <h4 className="qr-title">Pickup QR Code</h4>}
      
      <div className="qr-code-wrapper">
        <img 
          src={qrCodeUrl} 
          alt={`QR Code for Order ${orderId}`}
          className="qr-code-image"
          style={{ width: config.width, height: config.width }}
        />
      </div>
      
      <div className="qr-info" style={{ fontSize: config.fontSize }}>
        <p className="qr-description">
          📱 Show this QR code to the restaurant staff when picking up your order
        </p>
        <p className="order-reference">
          Order #{orderId.substring(orderId.length - 6)}
        </p>
      </div>
      
      <div className="qr-actions">
        <button 
          className="download-qr-btn" 
          onClick={handleDownload}
          title="Download QR Code"
        >
          💾 Download QR Code
        </button>
      </div>
    </div>
  );
};

export default OrderQRCode; 